<template lang="pug">
  .row
    .col-lg-10
      .d-flex.flex-row.align-items-center
        i.far.fa-user.account-page__icon
        h3.account-page__title {{ trans('labels.frontend.account.profile.account') }}
      h4.account-page__section-title {{ trans('labels.frontend.account.profile.personal-details') }}
      form.mb-3(@submit.prevent='onSave')
        .row
          .col-12.col-lg-6
            .form-group.form-group--required(:class="{ 'form-group--error': $v.user.first_name.$error }")
              label.control-label(for='first_name') {{ trans('labels.frontend.user.profile.first_name') }}
              input.form-control(
                type='text'
                id='first_name'
                name='first_name'
                maxlength='199'
                :placeholder="trans('labels.frontend.user.profile.first_name')"
                v-model.trim="$v.user.first_name.$model"
                required
              )
          .col-12.col-lg-6
            .form-group.form-group--required(:class="{ 'form-group--error': $v.user.last_name.$error }")
              label.control-label(for='last_name') {{ trans('labels.frontend.user.profile.last_name') }}
              input.form-control(
                type='text'
                id='last_name'
                name='last_name'
                maxlength='199'
                :placeholder="trans('labels.frontend.user.profile.last_name')"
                v-model.trim="$v.user.last_name.$model"
                required
              )
        .row
          .col-12.col-lg-6
            .form-group.form-group--required(:class="{ 'form-group--error': $v.user.email.$error }")
              label.control-label(for='email') {{ trans('labels.frontend.user.profile.email') }}
              input.form-control(
                type='email'
                id='email'
                name='email'
                maxlength='199'
                :placeholder="trans('labels.frontend.user.profile.email')"
                v-model.trim="$v.user.email.$model"
                readonly="readonly"
              )
          .col-12.col-lg-6
            .form-group.form-group--required(:class="{ 'form-group--error': $v.user.tel.$error }")
              label.control-label(for='tel') {{ trans('labels.frontend.user.profile.tel') }}
              cleave.form-control(
                id='tel'
                name='tel'
                :placeholder="trans('labels.frontend.user.profile.tel')"
                v-model="$v.user.tel.$model"
                :options="inputOptions.tel"
              )
        button.btn.btn-primary.btn-md.btn-long-md(type='button' disabled="disabled" v-if="$wait.is('saving profile')")
          font-awesome-icon(:icon="['far', 'circle-notch']" spin).mr-2
          | {{ trans('labels.general.buttons.saving') }}
        button.btn.btn-primary.btn-md.btn-long-md(
          type='button'
          @click="onSave"
          :disabled="$v.$invalid"
          v-if="!$wait.is('saving profile')"
        ) {{ trans('labels.general.buttons.save') }}
      h4.account-page__section-title {{ trans('labels.frontend.account.profile.shipping-address') }}
      shipping-address-box(
        :address="address"
        v-if="user.shipping_addresses"
        v-for="address in user.shipping_addresses"
        :key="address.id"
        @updated="getUser"
        @deleted="getUser"
      )
      create-address-button(type="shipping" @created="getUser")
      h4.account-page__section-title.mt-5 {{ trans('labels.frontend.account.profile.billing-address') }}
      billing-address-box(
        :address="address"
        v-if="user.billing_addresses"
        v-for="address in user.billing_addresses"
        :key="address.id"
        @updated="getUser"
        @deleted="getUser"
      )
      create-address-button(type="billing" @created="getUser")
</template>

<script>
import Cleave from 'vue-cleave-component';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import BreadcrumbsManager from '../../../mixins/BreadcrumbsManager';
import BillingAddressBox from '../../../components/account/BillingAddressBox.vue';
import ShippingAddressBox from '../../../components/account/ShippingAddressBox.vue';
import CreateAddressButton from '../../../components/account/CreateAddressButton.vue';
import notify from '../../../components/notify';

import 'cleave.js/src/addons/phone-type-formatter.th';

export default {
  metaInfo() {
    return {
      title: Lang.get('labels.frontend.account.profile.account'),
    };
  },
  components: {
    BillingAddressBox,
    Cleave,
    ShippingAddressBox,
    CreateAddressButton,
  },
  mixins: [BreadcrumbsManager, validationMixin],
  data() {
    return {
      user: {},
      inputOptions: {
        tel: {
          phone: true,
          phoneRegionCode: 'TH',
          delimiter: '',
        },
      },
    };
  },
  created() {
    this.getUser();
    this.setBreadcrumbs([
      { name: Lang.get('labels.frontend.account.profile.account') },
    ]);
  },
  methods: {
    async getUser() {
      try {
        await this.$store.dispatch('account/get', { with: 'shipping_addresses|billing_addresses' }).then((resp) => {
          this.user = resp.data;
        });
      } catch (e) {
        notify.errors(this, e);
      }
    },
    async onSave() {
      this.$wait.start('saving profile');

      try {
        await this.$store.dispatch('account/update_profile', this.user);
        notify.clean(this).then(() => notify.success(this, { title: Lang.get('alerts.general.operation_completed') }));
      } catch (err) {
        notify.clean(this).then(() => notify.errors(this, err));
      }
      this.$wait.end('saving profile');
    },
  },
  validations: {
    user: {
      email: {
        required,
        email,
      },
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      tel: {
        required,
      },
    },
  },
};
</script>
